import { useMemo } from 'react';

import { getOfficeLabelsByInvestmentOfficeId } from 'commons/office-labels';

import useGlobalApp from './useGlobalApp';

const useOfficeLabels = () => {
  const { investmentOfficeId } = useGlobalApp();

  return useMemo(
    () => getOfficeLabelsByInvestmentOfficeId(String(investmentOfficeId || '')),
    [investmentOfficeId],
  );
};

export default useOfficeLabels;
